import { useCallback, useMemo } from 'react';
import { SurveyCakeLogicEngine } from '@surveycake/logic-engine';
import {
  useEngineInstance,
  useSubjectId,
  useSubjectAnswers,
  UseSubjectAnswersSelector
} from '@surveycake/react-logic-engine';
import { addOptionPrefix } from 'app/modules/subject';

export function useNestAnswerConfig(engine: SurveyCakeLogicEngine, id: number) {
  return useMemo(() => {
    const { childs, options } = engine.getSubjectData(id);
    return {
      childIds: childs ? childs.map(child => child.ID) : [],
      options: options
        ? options.map(({ text, ID }) => ({
            Id: ID,
            label: text,
            value: addOptionPrefix(ID)
          }))
        : []
    };
  }, [engine, id]);
}

const answersSelector: UseSubjectAnswersSelector<string> = answers =>
  (answers.payload[0] as string) || '';

export function useNestAnswer() {
  const engine = useEngineInstance();
  const id = useSubjectId();
  const text = useMemo(() => engine.getSubjectData(id).text, [engine, id]);
  const valueFromAnswer = useSubjectAnswers(id, answersSelector);
  const onChange = useCallback(
    (selectedValue: string, checked: boolean) => {
      const payload = checked ? [selectedValue] : [];
      engine.setAnswer(id, { payload });
    },
    [engine, id]
  );

  return { id, text, valueFromAnswer, onChange };
}
